module.exports = __webpack_public_path__ + "img/predictive_analytic_module.a4381f9d.png";